/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { useEffect } from 'react';
import { styled } from 'styled-components';
import Footer from './components/Footer';
import NavigationContainer from './navigation/NavigationContainer';
import config from './config';

function App() {
    useEffect(() => {
        Object.assign(document.body.style, bodyBackgroundStyles);
    }, []);

    return (
        <>
            <MainContainer className='App'>
                <NavigationContainer />
                <Footer />
            </MainContainer>
        </>
    );
}

export default App;

const bodyBackgroundStyles = {
    backgroundImage: `url(${config.baseCDNURL}images/loginPage/Wave-BG-web-large.svg)`,
    backgroundSize: 'cover',
};

const MainContainer = styled.main`
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    label {
        font-size: 14px;
    }
    h1 {
        font-size: 36px;
        inline-size: 480px;
    }
    @media (max-width: 500px) {
        width: 90%;
        padding: 10%;
    }
`;
